


















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import CategoryBase from './CategoryBase'
import CategoryForm from '@/components/CategoryForm.vue'
import Table from '@/components/Table.vue'
import CardTable from '@/components/CardTable.vue'
import Loader from '@/components/Loader.vue'
import Confirm from '@/components/Confirm.vue'
import Modal from '@/components/Modal.vue'
import { Category } from '@/models/Category'

interface SingleCategoryEdit {
	name: string,
	category: Category,
}

@Component({
	components: {
		CategoryForm,
		Table,
		CardTable,
		Loader,
		Confirm,
		Modal,
	},
})
export default class CategoriesView extends CategoryBase {
	private headers: object[] = [
		{ main: 1, label: 'Name', name: 'name' },
		// { main: 1, label: 'Description', name: 'description' },
	]
	private singleItemEdit: SingleCategoryEdit = { name: '', category: new Category() }
	private showEdit: boolean = false

	get rows() {
		const rows = this.categories.models.map((category) => {
			return {
				id: category.id,
				name: category.name,
				// description: category.description,
			}
		})
		return rows
	}

	get tableView() {
		return this.$store.getters.tableView
	}

	private editCategory(id: string) {
		this.$router.push({ name: 'edit-category', params: { id } })
	}

	private confirmDelete(id: number) {
		const confirm = this.$refs.confirm as Confirm
		const deleteItem = this.categories.models.find((item: Category) => item.id === id)
		confirm.create(`This will permanently delete the category.`).then(() => {
			this.$store.dispatch('deleteCategory', deleteItem)
				.then(() => this.$toasted.success('Category deleted successfully.'),
				(error: any) => this.$toasted.error(`Failed to delete category.`))
		})
	}

	private editSingle(id: number, name: string) {
		const editArray = this.categories.models.filter((item: any) => item.id === id)
		this.singleItemEdit.category = editArray[0] || null
		this.singleItemEdit.name = name
		this.showEdit = true
	}

	private resetSingleItemEdit() {
		if (this.singleItemEdit.category) {
			this.singleItemEdit.category.reset()
		}
	}

	private updateSingleItem(category: Category) {
		this.$store.dispatch('saveCategory', category)
			.then(() => {
				this.$toasted.success('Category updated.')
				this.showEdit = false
			}, (error: any) => {
				this.$toasted.error(`Error: ${category.errorArray}`)
				category.reset()
			})
	}
}
